/* Hover supplements Shopify's existing click and keyboard navigation. */
(() => {
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const bound = new WeakSet();
  function bind(root = document) {
    root.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      if (bound.has(menu)) return;
      bound.add(menu);
      const details = menu.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!summary) return;
      let timer;
      const close = () => {
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      };
      menu.addEventListener('pointerenter', (event) => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach((other) => {
          if (other !== details) {
            other.open = false;
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
      menu.addEventListener('pointerleave', (event) => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!menu.contains(document.activeElement)) close();
        }, 180);
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        clearTimeout(timer);
        if (details.open) {
          event.preventDefault();
          close();
          summary.focus();
        }
      });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
      });
    });
  }
  bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
